import { Links, Meta, Outlet, Scripts, ScrollRestoration } from "react-router";
import "./styles/app.css";

if (import.meta.env.VITE_ADMIN_ENV === "prod") {
  // Disable console logs in production
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en">
      <head>
        <meta name="robots" content="noindex" />
        <meta name="googlebot" content="noindex" />
        <meta charSet="utf-8" />
        <link rel="icon" href="/influxer.svg" />
        {/* <link rel="stylesheet" href="assets/app.css" /> */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content="Web site created using create-react-app"
        />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link rel="manifest" href="/manifest.json" />

        <title>Influxer Admin</title>
        <Meta />
        <Links />
      </head>

      <body>
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export default function Root() {
  return <Outlet />;
}
